module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			},
			{
				"name": "View All Categories",
				"url": "/category"
			}
		]
	},
	{
		"name": "PHP Scripts",
		"url": "/category/php-scripts",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=php-scripts",
				"isTop": true
			},
			{
				"name": "Add-ons",
				"url": "/category/php-scripts/add-ons"
			},
			{
				"name": "Calendars",
				"url": "/category/php-scripts/calendars"
			},
			{
				"name": "Countdowns",
				"url": "/category/php-scripts/countdowns"
			},
			{
				"name": "Database Abstractions",
				"url": "/category/php-scripts/database-abstractions"
			},
			{
				"name": "Forms",
				"url": "/category/php-scripts/forms"
			},
			{
				"name": "Help and Support Tools",
				"url": "/category/php-scripts/help-and-support-tools"
			},
			{
				"name": "Images and Media",
				"url": "/category/php-scripts/images-and-media"
			},
			{
				"name": "Loaders and Uploaders",
				"url": "/category/php-scripts/loaders-and-uploaders"
			},
			{
				"name": "Navigation",
				"url": "/category/php-scripts/navigation"
			},
			{
				"name": "News Tickers",
				"url": "/category/php-scripts/news-tickers"
			},
			{
				"name": "Polls",
				"url": "/category/php-scripts/polls"
			},
			{
				"name": "Project Management Tools",
				"url": "/category/php-scripts/project-management-tools"
			},
			{
				"name": "Ratings and Charts",
				"url": "/category/php-scripts/ratings-and-charts"
			},
			{
				"name": "Search",
				"url": "/category/php-scripts/search"
			},
			{
				"name": "Shopping Carts",
				"url": "/category/php-scripts/shopping-carts"
			},
			{
				"name": "Social Networking",
				"url": "/category/php-scripts/social-networking"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/php-scripts/miscellaneous"
			}
		]
	},
	{
		"name": "WordPress",
		"url": "/category/wordpress",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=wordpress",
				"isTop": true
			},
			{
				"name": "Add-ons",
				"url": "/category/wordpress/add-ons"
			},
			{
				"name": "Advertising",
				"url": "/category/wordpress/advertising"
			},
			{
				"name": "Auctions",
				"url": "/category/wordpress/auctions"
			},
			{
				"name": "Calendars",
				"url": "/category/wordpress/calendars"
			},
			{
				"name": "eCommerce",
				"url": "/category/wordpress/ecommerce"
			},
			{
				"name": "Forms",
				"url": "/category/wordpress/forms"
			},
			{
				"name": "Forums",
				"url": "/category/wordpress/forums"
			},
			{
				"name": "Galleries",
				"url": "/category/wordpress/galleries"
			},
			{
				"name": "Interface Elements",
				"url": "/category/wordpress/interface-elements"
			},
			{
				"name": "Layers WP",
				"url": "/attributes/compatible-with/layers%20wp"
			},
			{
				"name": "Media",
				"url": "/category/wordpress/media"
			},
			{
				"name": "Membership",
				"url": "/category/wordpress/membership"
			},
			{
				"name": "Newsletters",
				"url": "/category/wordpress/newsletters"
			},
			{
				"name": "SEO",
				"url": "/category/wordpress/seo"
			},
			{
				"name": "Social Networking",
				"url": "/category/wordpress/social-networking"
			},
			{
				"name": "Utilities",
				"url": "/category/wordpress/utilities"
			},
			{
				"name": "Widgets",
				"url": "/category/wordpress/widgets"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/wordpress/miscellaneous"
			},
			{
				"name": "WordPress Themes on ThemeForest",
				"url": "http://themeforest.net/category/wordpress",
				"isBottom": true
			}
		]
	},
	{
		"name": "eCommerce",
		"url": "/tags/ecommerce",
		"children": [
			{
				"name": "Easy Digital Downloads",
				"url": "/search?compatible_with=Easy+Digital+Downloads"
			},
			{
				"name": "Jigoshop",
				"url": "/category/wordpress/ecommerce/jigoshop"
			},
			{
				"name": "Magento Extensions",
				"url": "/category/plugins/magento-extensions"
			},
			{
				"name": "OpenCart",
				"url": "/category/plugins/opencart"
			},
			{
				"name": "osCommerce",
				"url": "/category/plugins/oscommerce"
			},
			{
				"name": "Prestashop",
				"url": "/category/plugins/prestashop"
			},
			{
				"name": "UberCart",
				"url": "/category/plugins/ubercart"
			},
			{
				"name": "VirtueMart",
				"url": "/category/plugins/virtuemart"
			},
			{
				"name": "WooCommerce",
				"url": "/category/wordpress/ecommerce/woocommerce"
			},
			{
				"name": "WP e-Commerce",
				"url": "/category/wordpress/ecommerce/wp-e-commerce"
			},
			{
				"name": "WP Standalone",
				"url": "/category/wordpress/ecommerce/standalone"
			},
			{
				"name": "Zen Cart",
				"url": "/category/plugins/zen-cart"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/wordpress/ecommerce/miscellaneous"
			}
		]
	},
	{
		"name": "JavaScript",
		"url": "/category/javascript",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=javascript",
				"isTop": true
			},
			{
				"name": "Animated SVGs",
				"url": "/category/javascript/animated-svgs"
			},
			{
				"name": "Calendars",
				"url": "/category/javascript/calendars"
			},
			{
				"name": "Countdowns",
				"url": "/category/javascript/countdowns"
			},
			{
				"name": "Database Abstractions",
				"url": "/category/javascript/database-abstractions"
			},
			{
				"name": "Forms",
				"url": "/category/javascript/forms"
			},
			{
				"name": "Images and Media",
				"url": "/category/javascript/images-and-media"
			},
			{
				"name": "Loaders and Uploaders",
				"url": "/category/javascript/loaders-and-uploaders"
			},
			{
				"name": "Media",
				"url": "/category/javascript/media"
			},
			{
				"name": "Navigation",
				"url": "/category/javascript/navigation"
			},
			{
				"name": "News Tickers",
				"url": "/category/javascript/news-tickers"
			},
			{
				"name": "Project Management Tools",
				"url": "/category/javascript/project-management-tools"
			},
			{
				"name": "Ratings and Charts",
				"url": "/category/javascript/ratings-and-charts"
			},
			{
				"name": "Shopping Carts",
				"url": "/category/javascript/shopping-carts"
			},
			{
				"name": "Sliders",
				"url": "/category/javascript/sliders"
			},
			{
				"name": "Social Networks",
				"url": "/category/javascript/social-networks"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/javascript/miscellaneous"
			}
		]
	},
	{
		"name": "CSS",
		"url": "/category/css",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=css",
				"isTop": true
			},
			{
				"name": "Animations and Effects",
				"url": "/category/css/animations-and-effects"
			},
			{
				"name": "Buttons",
				"url": "/category/css/buttons"
			},
			{
				"name": "Charts and Graphs",
				"url": "/category/css/charts-and-graphs"
			},
			{
				"name": "Forms",
				"url": "/category/css/forms"
			},
			{
				"name": "Layouts",
				"url": "/category/css/layouts"
			},
			{
				"name": "Navigation and Menus",
				"url": "/category/css/navigation-and-menus"
			},
			{
				"name": "Pricing Tables",
				"url": "/category/css/pricing-tables"
			},
			{
				"name": "Tabs and Sliders",
				"url": "/category/css/tabs-and-sliders"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/css/miscellaneous"
			}
		]
	},
	{
		"name": "Mobile",
		"url": "/category/mobile",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=mobile",
				"isTop": true
			},
			{
				"name": "Android",
				"url": "/category/mobile/android"
			},
			{
				"name": "iOS",
				"url": "/category/mobile/ios"
			},
			{
				"name": "Native Web",
				"url": "/category/mobile/native-web"
			},
			{
				"name": "Titanium",
				"url": "/category/mobile/titanium"
			}
		]
	},
	{
		"name": "HTML5",
		"url": "/category/html5",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=html5",
				"isTop": true
			},
			{
				"name": "3D",
				"url": "/category/html5/3d"
			},
			{
				"name": "Ad Templates",
				"url": "/category/html5/ad-templates"
			},
			{
				"name": "Canvas",
				"url": "/category/html5/canvas"
			},
			{
				"name": "Charts and Graphs",
				"url": "/category/html5/charts-and-graphs"
			},
			{
				"name": "Forms",
				"url": "/category/html5/forms"
			},
			{
				"name": "Games",
				"url": "/category/html5/games"
			},
			{
				"name": "Libraries",
				"url": "/category/html5/libraries"
			},
			{
				"name": "Media",
				"url": "/category/html5/media"
			},
			{
				"name": "Presentations",
				"url": "/category/html5/presentations"
			},
			{
				"name": "Sliders",
				"url": "/category/html5/sliders"
			},
			{
				"name": "Storage",
				"url": "/category/html5/storage"
			},
			{
				"name": "Templates",
				"url": "/category/html5/templates"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/html5/miscellaneous"
			}
		]
	},
	{
		"name": "Skins",
		"url": "/category/skins",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=skins",
				"isTop": true
			},
			{
				"name": "Bootstrap",
				"url": "/category/skins/bootstrap"
			},
			{
				"name": "Layers WP Style Kits",
				"url": "/category/skins/layers-wp-style-kits"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/skins/miscellaneous"
			}
		]
	},
	{
		"name": "WP Themes",
		"url": "http://themeforest.net/category/wordpress",
		"children": []
	},
	{
		"name": "Plugins",
		"url": "/category/plugins",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=plugins",
				"isTop": true
			},
			{
				"name": "Concrete5",
				"url": "/category/plugins/concrete5"
			},
			{
				"name": "Drupal",
				"url": "/category/plugins/drupal"
			},
			{
				"name": "ExpressionEngine",
				"url": "/category/plugins/expressionengine"
			},
			{
				"name": "Joomla",
				"url": "/category/plugins/joomla"
			},
			{
				"name": "Magento Extensions",
				"url": "/category/plugins/magento-extensions"
			},
			{
				"name": "Muse Widgets",
				"url": "/category/plugins/muse-widgets"
			},
			{
				"name": "OpenCart",
				"url": "/category/plugins/opencart"
			},
			{
				"name": "osCommerce",
				"url": "/category/plugins/oscommerce"
			},
			{
				"name": "Prestashop",
				"url": "/category/plugins/prestashop"
			},
			{
				"name": "Ubercart",
				"url": "/category/plugins/ubercart"
			},
			{
				"name": "VirtueMart",
				"url": "/category/plugins/virtuemart"
			},
			{
				"name": "Zen Cart",
				"url": "/category/plugins/zen-cart"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/plugins/miscellaneous"
			}
		]
	},
	{
		"name": "More",
		"url": "/category",
		"children": [
			{
				"name": ".NET",
				"url": "/category/net"
			},
			{
				"name": "Apps",
				"url": "/category/apps"
			},
			{
				"name": "Edge Animate Templates",
				"url": "/category/edge-animate-templates"
			},
			{
				"name": "Facebook",
				"url": "/search?term=facebook&type=files"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/menus/codecanyon.json
// module id = 480
// module chunks = 1